<template lang="pug">
div
  el-table(:data='formdata.slides', style='width: 100%', max-height='500')
    el-table-column(label='id', width='100')
      template(slot-scope='scope')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'ja' }}")
          | {{scope.row.entry_id}}
    el-table-column(label='タイトル', width='400')
      template(slot-scope='scope')
        router-link(:to="{ path: editPath, query: { id: scope.row.entry_id, locale: 'ja' }}")
          | {{scope.row.title}}
    el-table-column(label='登録日', width='200')
      template(slot-scope='scope')
        | {{scope.row.created_at | moment}}
    el-table-column(label='更新日', width='200')
      template(slot-scope='scope')
        | {{scope.row.updated_at | moment}}
    el-table-column(fixed='right', label='Operations', width='200')
      template(slot-scope='scope')
        el-button(size='mini', type='primary', icon='el-icon-caret-top', @click='moveListUp(scope.$index)')
        el-button(size='mini', type='primary', icon='el-icon-caret-bottom', @click='moveListDown(scope.$index)')
        el-button(size='mini', type='danger', icon='el-icon-delete', @click='deleteConfirm(scope.$index)')
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
    }
  },
  components: {
  },
  props: {
    formdata: Object,
    editPath: String
  },
  filters: {
    moment: function (date) {
      return moment(date).format('YYYY/MM/DD HH:mm:ss')
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    moveListUp (orgIndex) {
      if (orgIndex > 0) {
        let target = orgIndex - 1
        let tmp = this.formdata.slides.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.slides[orgIndex])
        this.formdata.slides = tmp
      }
    },
    moveListDown (orgIndex) {
      if (orgIndex < this.formdata.slides.length) {
        let target = orgIndex + 1
        let tmp = this.formdata.slides.filter((_, index) => index !== orgIndex)
        tmp.splice(target, 0, this.formdata.slides[orgIndex])
        this.formdata.slides = tmp
      }
    },
    deleteConfirm (index) {
      this.$confirm('削除しますか？', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
        center: true
      }).then(() => {
        this.formdata.slides.splice(index, 1)
        this.$message({
          type: 'success',
          message: 'Delete completed'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        })
      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/components/swan/top/slideList.vue